import MyTableTag from './tableTag.vue';

MyTableTag.install = function(Vue){
  Vue.component('MyTableTag', MyTableTag);
};

export default MyTableTag;